import React from 'react';
import { Stack, StackProps } from '@chakra-ui/react';

export const InfoBox: React.FC<StackProps> = React.forwardRef<HTMLDivElement, StackProps>((props, ref) => (
  <Stack bg="gray.100" border="1px" borderStyle="dashed" p="2" spacing="3" {...props} ref={ref}>
    {props.children}
  </Stack>
));
